import { type MouseEventData } from '../external-types';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';
import SvgStamp, { STAMP_DEFAULT_SIZE } from '../objects/SvgStamp';
import type StylusSvgStamp from './StylusSvgStamp';
import DraggableBrush from './DraggableBrush';

// Brush for drawing stamp objects.
class SvgStampDrawingBrush extends DraggableBrush {
  canvas: Canvas;
  stylus: StylusSvgStamp;
  clickStart: { pointer: IPoint };

  constructor(canvas: Canvas, stylus: StylusSvgStamp) {
    super();
    this.canvas = canvas;
    this.stylus = stylus;
    this.clickStart = { pointer: { x: 0, y: 0 } };
  }

  async startDragging(pointer: IPoint) {
    return this._createStamp(pointer);
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }

    this.canvas.controller.actionSetStylusMenu(null);
    this._createStamp(pointer);
  }

  onMouseMove() {}

  onMouseUp(eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return true;
    }
    this.stylus.drawingComplete();
    this.canvas.controller.undoManager.completeUndoGroup();

    return false;
  }

  _createStamp(pointer: IPoint) {
    const scale = this.canvas.getZoom();
    const stamp = new SvgStamp({
      controller: this.canvas.controller,
      svg: this.stylus.options.svg,
      left: pointer.x - STAMP_DEFAULT_SIZE / scale / 2,
      top: pointer.y - STAMP_DEFAULT_SIZE / scale / 2,
      scaleX: 1 / scale,
      scaleY: 1 / scale,
    });

    this.canvas.controller.addToCanvas(stamp);
    return stamp;
  }

  _render() {}
}

export default SvgStampDrawingBrush;
